import { createContext } from "react";

export type TranslateFn = (key: TranslationKey) => string;

export const TranslationContext = createContext<{
  translate: TranslateFn;
  translations: TranslationModel;
}>({
  translate: () => "",
  translations: {} as any,
});

export type TranslationKey =
  | "yes"
  | "no"
  | "nav_logout"
  | "not_found_title"
  | "shared_login"
  | "privacy_policy"
  | "accessibility"
  | "locale_fi"
  | "locale_en"
  | "locale_sv"
  | "show_in_locale_fi"
  | "show_in_locale_en"
  | "show_in_locale_sv"
  | "no_rows"
  | "go_back"
  | "user_status"

  // login
  | "login_title"
  | "login_error"
  | "login_or"
  | "login_with_ftn"
  | "login_button"
  | "login_label_email"
  | "login_label_password"
  | "login_link_expired_title"
  | "login_link_expired_text"
  | "login_link_p1"
  | "login_link_p2"
  | "login_begin_auth"

  // field datatypes
  | "field_datatype_text"
  | "field_datatype_textarea"
  | "field_datatype_email"
  | "field_datatype_date"
  | "field_datatype_datetime"
  | "field_datatype_dropdown"
  | "field_datatype_check"
  | "field_datatype_ssn"
  | "field_datatype_phone"
  | "field_datatype_radio"
  | "user_status_draft"
  | "user_status_invited"
  | "user_status_progress"
  | "user_status_submitted"
  | "user_status_approved"
  | "email_filter_all"
  | "email_filter_draft"
  | "email_template_type_invitation"
  | "email_template_type_reminder"
  | "email_template_type_update_request"
  | "email_template_type_rejected"
  | "email_template_type_approved"
  | "email_template_type_custom"
  | "column_type_field"
  | "column_type_name"
  | "column_type_liabilities"
  | "column_type_modified"
  | "column_type_status"
  | "column_width_automatic"
  | "pdf_status"
  | "pdf_date"
  | "pdf_contains_secret_material"
  | "validate_required"
  | "validate_email"
  | "validate_phone"
  | "validate_ssn"
  | "validate_password_min8"
  | "validate_localestring_translation_missing"
  | "validate_password_same_as_old"
  | "validate_password_do_not_match"
  | "email_event_type_bounce"
  | "email_event_type_click"
  | "email_event_type_delivery"
  | "email_event_type_open"
  | "email_event_type_reject"
  | "email_event_type_complaint";

export type TranslationModel = Record<TranslationKey, string>;
